(function (global) {
  'use strict';

  //Internal config values
  var wsConfig = {
    outsideUrl: 'outside.html',
    indexUrl: 'index.html',
    apiUrl: '../api',
    logLevel: 'none',
    helpUrl: '#/help'
  };

  //See if an external configuration has been setup
  if (typeof global.wsconfig !== "undefined") {
    angular.extend(wsConfig, global.wsconfig);
  }

  //Register config
  angular.module('wsLrs.config', []).constant('wsConfig', wsConfig).constant('wsApiUrl', wsConfig.apiUrl);
  global.wsConfig = wsConfig;
})(this);
